export enum MoneyMarketTickers {
  VMRXX = 'VMRXX',
  VMSXX = 'VMSXX',
  VYFXX = 'VYFXX',
  VUSXX = 'VUSXX',
  VCTXX = 'VCTXX',
}
